module.exports = __webpack_public_path__ + "img/8m.e884ec32.gif";